module.exports = __webpack_public_path__ + "img/img3.9d9e2930.jpg";